import React, {useEffect, useState} from 'react';
import {Button, Container, FormControl, Grid, InputLabel, Select, Stack} from "@mui/material";
import BackServer from "../../api/BackServer";
import Checkbox from '@mui/material/Checkbox';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import FilterEdit from "../FilterEdit/FilterEdit";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import {baseUrl_back} from "../../api/BaseUrl";
import SendIcon from '@mui/icons-material/Send';
import FilrerEditString from "../FilrerEditString/FilrerEditString";
import {toast} from "react-toastify";

const nrtheme22 = createTheme({
    palette: {
        primary: {
            main: '#382b2f',
        },
        secondary: {
            main: '#f3edef',
        },
        text: {
            primary: '#382b2f',
            secondary: 'rgba(255,255,255,0.7)',
            hint: '#ffc400',
            disabled: 'rgba(142,232,6,0.5)',
        },
        type: 'dark',
    },
});


const ProductAdd = () => {
    const [age, setAge] = React.useState('');
    const [imageUrl, setimageUrl] = React.useState('');

    const [VCategories, setVCategories]= useState([])
    const [Vname, setVname]= useState("?")
    const [Varticle, setVarticle]= useState("?")
    const [VColors, setVColors]= useState([])
    const [VMaterial, setVMaterial]= useState([])
    const [VModelOnPfoto, setVModelOnPfoto]= useState("?")
    const [VPrice, setVPrice]= useState("?")
    const [VPriceBefore, setVPriceBefore]= useState("?")
    const [VRating, setVRating]= useState(5)
    const [VSeason, setVSeason]= useState([])
    const [VSizes, setVSizes]= useState([])
    const [VSizesAvailability, setVSizesAvailability]= useState([])
    const [Vavailability_text, setVavailability_text]= useState("?")
    const [Vcomponents, setVcomponents]= useState("?")
    const [VdecorativeElements, setVdecorativeElements]= useState([])
    const [VmaxTermal, setVmaxTermal]= useState(20)
    const [VminTermal, setVminTermal]= useState(-20)
    const [Vmicro_description, setVmicro_description]= useState()
    const [Vdescription, setVdescription]= useState([])
    const [Vmini_description, setVmini_description]= useState()
    const [VmodelFeatures, setVmodelFeatures]= useState([])
    const [Vsort_index, setVsort_index]= useState(50)
    const [Vsports, setVsports]= useState([])
    const [Vtags, setVtags]= useState([])
    const [VBuyWithThis, setVBuyWithThis]= useState([])
    const [VGoodsBrothersID, setVGoodsBrothersID]= useState([])
    const [VWeight, setVWeight]= useState(100)




    const [name, setname]= useState([])
    const [Categories, setCategories]= useState([])
    const [article, setarticle]= useState([])
    const [Colors, setColors]= useState([])
    const [Material, setMaterial]= useState([])
    const [ModelOnPfoto, setModelOnPfoto]= useState([])
    const [Price, setPrice]= useState([])
    const [PriceBefore, setPriceBefore]= useState([])
    const [Rating, setRating]= useState([])
    const [Season, setSeason]= useState([])
    const [Sizes, setSizes]= useState([])
    const [SizesAvailability, setSizesAvailability]= useState([])
    const [availability_text, setavailability_text]= useState([])
    const [availability_checkBox, setavailability_checkBox]= useState(true)
    const [show_checkBox, setshow_checkBox]= useState(true)
    const [show_PriceBefore_checkBox, setshow_PriceBefore_checkBox]= useState(true)
    const [components, setcomponents]= useState([])
    const [decorativeElements, setdecorativeElements]= useState([])
    const [maxTermal, setmaxTermal]= useState([])
    const [minTermal, setminTermal]= useState([])
    const [micro_description, setmicro_description]= useState([])
    const [description, setdescription]= useState([])
    const [mini_description, setmini_description]= useState([])
    const [modelFeatures, setmodelFeatures]= useState([])
    const [sort_index, setsort_index]= useState([])
    const [sports, setsports]= useState([])
    const [tags, settags]= useState([])
    const [BuyWithThis, setBuyWithThis]= useState([])
    const [GoodsBrothersID, setGoodsBrothersID]= useState([])
    const [Weight, setWeight]= useState([])





    const getProducts = async (xxx) => {
        var response=[]
        if (xxx == null)
        {
            response = await BackServer.GetDistinct()
            setCategories(response.message.Products.Categories)
            setname(response.message.Products.name)
            setarticle(response.message.Products.article)
            setColors(response.message.Products.Colors)
            setMaterial(response.message.Products.Material)
            setModelOnPfoto(response.message.Products.ModelOnPfoto)
            setPrice(response.message.Products.Price)
            setPriceBefore(response.message.Products.PriceBefore)
            setRating(response.message.Products.Rating)
            setSeason(response.message.Products.Season)
            setSizes(response.message.Products.Sizes)
            setSizesAvailability(response.message.Products.SizesAvailability)
            setavailability_text(response.message.Products.availability_text)
            setcomponents(response.message.Products.components)
            setdecorativeElements(response.message.Products.decorativeElements)
            setmaxTermal(response.message.Products.maxTermal)
            setminTermal(response.message.Products.minTermal)
            setmicro_description(response.message.Products.micro_description)
            setdescription(response.message.Products.description)
            setmini_description(response.message.Products.mini_description)
            setmodelFeatures(response.message.Products.modelFeatures)
            setsort_index(response.message.Products.sort_index)
            setsports(response.message.Products.sports)
            settags(response.message.Products.tags)
            setBuyWithThis(response.message.Products.BuyWithThis)
            setGoodsBrothersID(response.message.Products.GoodsBrothersID)
            setWeight(response.message.Products.Weight)
            console.log(response)
            console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaa")
         } else {
            response = await BackServer.GetProductById(xxx)
            setVCategories(response.message.products[0].Categories)
            setVname(response.message.products[0].name)
            setVarticle(response.message.products[0].article)
            setVColors(response.message.products[0].Colors)
            setVMaterial(response.message.products[0].Material)
            setVModelOnPfoto(response.message.products[0].ModelOnPfoto)
            setVPrice(response.message.products[0].Price)
            setVPriceBefore(response.message.products[0].PriceBefore)
            setVRating(response.message.products[0].Rating)
            setVSeason(response.message.products[0].Season)
            setVSizes(response.message.products[0].Sizes)
            setVSizesAvailability(response.message.products[0].SizesAvailability)
            setVavailability_text(response.message.products[0].availability_text)
            setVcomponents(response.message.products[0].components)
            setVdecorativeElements(response.message.products[0].decorativeElements)
            setVmaxTermal(response.message.products[0].maxTermal)
            setVminTermal(response.message.products[0].minTermal)
            setVmicro_description(response.message.products[0].micro_description)
            setVdescription(response.message.products[0].description)
            setVmini_description(response.message.products[0].mini_description)
            setVmodelFeatures(response.message.products[0].modelFeatures)
            setVsort_index(response.message.products[0].sort_index)
            setVsports(response.message.products[0].sports)
            setVtags(response.message.products[0].tags)
            setVBuyWithThis(response.message.products[0].BuyWithThis)
            setVGoodsBrothersID(response.message.products[0].GoodsBrothersID)
            setVWeight(response.message.products[0].Weight)
            setimageUrl(response.message.products[0].imageUrl)
            if (response.message.products[0].availability==true){
                setavailability_checkBox(true)
            } else
            {
                setavailability_checkBox(false)
            }

            if (response.message.products[0].show==true){
                setshow_checkBox(true)
            } else
            {
                setshow_checkBox(false)
            }
            if (response.message.products[0].PriceBeforeShow==true){
                setshow_PriceBefore_checkBox(true)
            } else
            {
                setshow_PriceBefore_checkBox(false)
            }


            console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee")
            console.log(response.message.products[0])
        }


    }
    useEffect(() => {
        getProducts(null)

    }, [])

    const cjeck =async (event) => {
        var MyData={}
        MyData["BuyWithThis"]= VBuyWithThis
        MyData["Categories"]= VCategories
        MyData["Colors"]= VColors
        MyData["GoodsBrothersID"]= VGoodsBrothersID
        MyData["Material"]= VMaterial
        MyData["ModelOnPfoto"]= VModelOnPfoto
        MyData["Price"]= VPrice
        MyData["PriceBefore"]= VPriceBefore
        MyData["PriceBeforeShow"]= show_PriceBefore_checkBox
        MyData["Rating"]= VRating
        MyData["Season"]= VSeason
        MyData["Sizes"]= VSizes
        MyData["SizesAvailability"]= VSizesAvailability
        MyData["Weight"]= VWeight
        MyData["article"]= Varticle
        MyData["availability"]= availability_checkBox
        MyData["availability_text"]= Vavailability_text
        MyData["components"]= Vcomponents
        MyData["decorativeElements"]= VdecorativeElements
        MyData["description"]= Vdescription
        MyData["maxTermal"]= VmaxTermal
        MyData["micro_description"]= Vmicro_description
        MyData["minTermal"]= VminTermal
        MyData["mini_description"]= Vmini_description
        MyData["modelFeatures"]= VmodelFeatures
        MyData["name"]= Vname
        MyData["show"]= show_checkBox
        MyData["sort_index"]= Vsort_index
        MyData["sports"]= Vsports
        MyData["tags"]= Vtags
        MyData["feedback"]= []
        console.log(MyData)
        console.log("dddddddddd")

        const response = await BackServer.AddEditProduct(MyData).then(u => {
            if (u) {
                console.log(u)
                // alert(response.data)
                toast.success(u.message.status, {
                    position: "top-center",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    // pauseOnHover: true,
                    draggable: false,
                    theme: "dark",
                });
            }
        }).catch(function (error) {
                    toast.error(error.response.data.message.status, {
                        position: "top-center", autoClose: 5000, hideProgressBar: false,
                        closeOnClick: true, pauseOnHover: true, draggable: true,
                        progress: undefined, theme: "colored",
                    });


            console.log(error.config);
        });


    };





    const FillData = (event) => {
        // console.log(responsex.message.Products.Categories)
        getProducts(age)

    };


    function MyCallBack(newValue,name)
    {
        if (name=="Название") {setVname(newValue);}
        if (name=="Категории") {setVCategories([...newValue,]);}

        if (name=="Артикул") {setVarticle(newValue);}

        if (name=="Цвета") {setVColors([...newValue,]);}
        if (name=="Материал") {setVMaterial([...newValue,]);}
        if (name=="Виды спорта") {setVsports([...newValue,]);}
        if (name=="Модель на фото") {setVModelOnPfoto(newValue);}
        if (name=="Цена ДО") {setVPriceBefore(newValue);}
        if (name=="Цена конечная") {setVPrice(newValue);}
        if (name=="Рейтинг") {setVRating(newValue);}
        if (name=="Сезон") {setVSeason([...newValue,]);}
        if (name=="Размеры") {setVSizes([...newValue,]);}
        if (name=="Вес в граммах") {setVWeight(newValue);}
        if (name=="Доступные размеры") {setVSizesAvailability([...newValue,]);}
        if (name=="Наличие текст") {setVavailability_text(newValue);}
        if (name=="Состав") {setVcomponents(newValue);}
        if (name=="Декоративные элементы") {setVdecorativeElements([...newValue,]);}
        if (name=="Максимальная t использования") {setVmaxTermal(newValue);}
        if (name=="Минимальная t использования") {setVminTermal(newValue);}
        if (name=="Микро-примечание") {setVmicro_description(newValue);}
        if (name=="Мини-примечание") {setVmini_description(newValue);}
        if (name=="Примечание") {setVdescription([...newValue,]);}
        if (name=="Особенности модели") {setVmodelFeatures([...newValue,]);}
        if (name=="Индекс сортировки  0 - начало 999- в конец") {setVsort_index(newValue);}
        if (name=="Тэги") {setVtags([...newValue,]);}
        if (name=="С этим товаром покупают") {setVBuyWithThis([...newValue,]);}
        if (name=="Похожие товары") {setVGoodsBrothersID([...newValue,]);}

    };


    const vnalichii = (event) => {
        setavailability_checkBox(event.target.checked);
    };
    const isshow = (event) => {
        setshow_checkBox(event.target.checked);
    };
    const isshowPriceBefore_checkBox = (event) => {
        setshow_PriceBefore_checkBox(event.target.checked);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    return (
        <ThemeProvider theme={nrtheme22}>
            <Container>
                <Stack   spacing={1.5}>

                    <Grid container spacing={0}>

                            <Grid item key={"1"}  lg={3} xl={3} md={3}>
                                <TextField
                                    variant="filled"
                                    label="Загрузить параметры из:"
                                />
                            </Grid>
                        <Grid item key={"2"}  lg={8} xl={8} sm={8} md={8}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Age</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={age}
                                        label="Age"
                                        onChange={handleChange}
                                    >

                                        {article.map((elm, key) => (
                                            // <Grid  key={key}  item xs={6} md={2.4}  sm={3} lg={2.4} xl={2}>
                                            <MenuItem key={key} value={elm}>{elm}</MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>
                        </Grid>

                        <Grid item key={"3"}  lg={1} xl={1} sm={1} md={1}>
                         <Button  size="large" endIcon={<SendIcon/>} variant="contained" onClick={FillData}>GO </Button>
                        </Grid>
                    </Grid>
                    <div className={"mycardDivSmall"}>
                        <img width={110} height={110} src={baseUrl_back+imageUrl} />

                    </div>


GET FILTERS RELOAD
                    <FilrerEditString names={"Артикул"} call={MyCallBack} val={Varticle} datas={article}/>
                    <FilrerEditString names={"Название"}  call={MyCallBack}  val={Vname}  datas={name}/>
                    <FilterEdit names={"Категории"} call={MyCallBack} val={VCategories}  datas={Categories}/>
                    <FilterEdit names={"Цвета"} call={MyCallBack} val={VColors}  datas={Colors}/>
                    <FilterEdit names={"Материал"} call={MyCallBack} val={VMaterial}  datas={Material}/>
                    <FilterEdit names={"Виды спорта"} call={MyCallBack} val={Vsports}  datas={sports}/>
                    <FilrerEditString names={"Модель на фото"} call={MyCallBack}  val={VModelOnPfoto}  datas={ModelOnPfoto}/>
                    <FilrerEditString names={"Цена ДО"} call={MyCallBack} val={VPriceBefore}  datas={PriceBefore}/>
                    <FormControlLabel control={<Checkbox checked={show_PriceBefore_checkBox} onChange={isshowPriceBefore_checkBox} />} label="Показывать цену ДО?" />
                    <FilrerEditString names={"Цена конечная"} call={MyCallBack} val={VPrice}  datas={Price}/>
                    <FilrerEditString names={"Рейтинг"} call={MyCallBack}  val={VRating} datas={Rating}/>
                    <FilterEdit names={"Сезон"} call={MyCallBack}  val={VSeason} datas={Season}/>
                    <FilterEdit names={"Размеры"} call={MyCallBack}  val={VSizes} datas={Sizes}/>
                    <FilrerEditString names={"Вес в граммах"} call={MyCallBack}  val={VWeight} datas={Weight}/>
                    <FilterEdit names={"Доступные размеры"} call={MyCallBack}  val={VSizesAvailability} datas={SizesAvailability}/>
                    <FilrerEditString names={"Наличие текст"} call={MyCallBack} val={Vavailability_text}  datas={availability_text}/>
                    <FilrerEditString names={"Состав"} call={MyCallBack} val={Vcomponents}  datas={components}/>
                    <FilterEdit names={"Декоративные элементы"} call={MyCallBack} val={VdecorativeElements}  datas={decorativeElements}/>
                    <FilrerEditString names={"Максимальная t использования"} call={MyCallBack}  val={VmaxTermal} datas={maxTermal}/>
                    <FilrerEditString names={"Минимальная t использования"} call={MyCallBack} val={VminTermal}  datas={minTermal}/>
                    <FilrerEditString names={"Микро-примечание"} call={MyCallBack} val={Vmicro_description}  datas={micro_description}/>
                    <FilrerEditString names={"Мини-примечание"} call={MyCallBack} val={Vmini_description}  datas={mini_description}/>
                    <FilterEdit names={"Примечание"}  call={MyCallBack} val={Vdescription} datas={description}/>
                    <FilterEdit names={"Особенности модели"} call={MyCallBack} val={VmodelFeatures}  datas={modelFeatures}/>
                    <FilrerEditString names={"Индекс сортировки  0 - начало 999- в конец"} call={MyCallBack} val={Vsort_index}  datas={sort_index}/>
                    <FilterEdit names={"Тэги"} val={Vtags} call={MyCallBack}  datas={tags}/>
                    <FilterEdit names={"С этим товаром покупают"} call={MyCallBack} val={VBuyWithThis}  datas={BuyWithThis}/>
                    <FilterEdit names={"Похожие товары"} call={MyCallBack} val={VGoodsBrothersID}  datas={GoodsBrothersID}/>
                    <FormControlLabel control={<Checkbox checked={availability_checkBox} onChange={vnalichii} />} label="Доступно к заказу" />
                    <FormControlLabel control={<Checkbox checked={show_checkBox} onChange={isshow} />} label="Показывать в каталоге?" />


                    <Button size="large" endIcon={<SendIcon/>} variant="contained" onClick={cjeck}>Отправить-Изменить </Button>

                </Stack>


            </Container>
        </ThemeProvider>
    );
};

export default ProductAdd;